import React from "react";
import { HiOutlineEmojiHappy } from "react-icons/hi";

const ReactionPicker = ({ messageId, onClose, position = "right", socket }) => {
    const emojis = ["👍", "❤️", "😂", "😮", "😢", "🔥"];

    const handleReaction = (emoji) => {
        if (socket) {
            socket.emit("add_reaction", { messageId, emoji });
        }
        onClose();
    };

    // Close on outside click
    React.useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".reaction-picker")) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    return (
        <div
            className={`reaction-picker absolute ${position === "left" ? "right-full mr-2" : "left-full ml-2"
                } top-0 z-50`}
        >
            <div className="bg-white/90 backdrop-blur-xl border border-white/40 shadow-xl rounded-full px-3 py-2 flex gap-2">
                {emojis.map((emoji) => (
                    <button
                        key={emoji}
                        onClick={() => handleReaction(emoji)}
                        className="text-2xl hover:scale-125 transition-transform cursor-pointer select-none"
                        aria-label={`React with ${emoji}`}
                    >
                        {emoji}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ReactionPicker;
